import { ISubscription } from "@oqdo/automationapps/Memberships/Subscription";

export const getStripeId = (s: ISubscription) => {
  const ext: any = s?.externalIds;
  return ext ? ext.StripeSubscriptionId : undefined;
};
